import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--conditional-link"
export default class extends Controller {
  static values = {
    containerSelector: String,
    markerSelector: String,
  };

  connect() {
    this.container = this.#resolveContainer();
    this.selector = this.markerSelectorValue;
    this.#evaluate();
    this.#observe();
  }

  disconnect() {
    this.#stopObserver();
  }

  #resolveContainer() {
    const selector = this.containerSelectorValue;
    if (!selector) return this.element;

    return this.element.closest(selector) || document.querySelector(selector);
  }

  #observe() {
    if (!this.container) return;

    this.#stopObserver();

    this.mutationObserver = new MutationObserver(() => this.#evaluate());
    this.mutationObserver.observe(this.container, {
      childList: true,
      subtree: true,
      attributes: false,
    });
  }

  #stopObserver() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  }

  #evaluate() {
    const hasMarker = this.selector && this.container?.querySelector(this.selector);
    if (hasMarker) {
      this.#enableLinkInteractions();
    } else {
      this.#disableLinkInteractions();
    }
  }

  #disableLinkInteractions() {
    this.element.classList.add('link--disabled');
    this.element.setAttribute('tabindex', '-1');
    this.element.setAttribute('aria-disabled', 'true');
  }

  #enableLinkInteractions() {
    this.element.classList.remove('link--disabled');
    this.element.removeAttribute('tabindex');
    this.element.removeAttribute('aria-disabled');
  }
}
